import React, { useState } from "react";
import { ShieldCheck, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export const GUARANTEES = ["Hypothèque", "Privilège de prêteur de deniers (PPD / IPPD)", "Caution mutuelle (Crédit Logement, CAMCA, SACCEF…)", "Caution personnelle", "Nantissement", "Autre"];

export const GuaranteeFields = ({ value, detail, onChange }) => (
  <div className="grid sm:grid-cols-2 gap-3">
    <label className="block text-xs font-medium text-brand-green/70">Garantie du prêt
      <select value={value || ""} onChange={(e) => onChange({ guarantee: e.target.value, guarantee_detail: detail })} className="inp mt-1" data-testid="loan-guarantee">
        <option value="">Non renseignée</option>
        {GUARANTEES.map((g) => <option key={g} value={g}>{g}</option>)}
      </select>
    </label>
    <label className="block text-xs font-medium text-brand-green/70">Précisions (organisme, montant, rang…)
      <input value={detail || ""} onChange={(e) => onChange({ guarantee: value, guarantee_detail: e.target.value })} placeholder="Ex. : Crédit Logement, hypothèque 1er rang" className="inp mt-1" data-testid="loan-guarantee-detail" />
    </label>
  </div>
);

export const GuaranteeBadge = ({ loan }) => (loan.guarantee ? (
  <span role="button" tabIndex={0} title={[loan.guarantee, loan.guarantee_detail].filter(Boolean).join(" — ")} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-sky-50 text-sky-800 border border-sky-200 text-[10px] font-semibold max-w-[220px] truncate" data-testid={`loan-guarantee-badge-${loan.id}`}>
    <ShieldCheck className="w-2.5 h-2.5 shrink-0" /> {loan.guarantee.split(" (")[0]}{loan.guarantee_detail ? ` · ${loan.guarantee_detail}` : ""}
  </span>
) : null);

export function GuaranteeModal({ loan, onClose, onSaved }) {
  const [v, setV] = useState({ guarantee: loan.guarantee || "", guarantee_detail: loan.guarantee_detail || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch(`/loans/${loan.id}/guarantee`, v);
      toast.success("Garantie enregistrée"); onSaved(r.data); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={onClose} data-testid="guarantee-modal">
      <div className="bg-white rounded-3xl w-full max-w-lg p-6 space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div><h3 className="font-display text-xl text-brand-greenDeep">Garantie du prêt</h3><p className="text-xs text-brand-green/60">{loan.payer_to || "Prêt"} — {loan.property || "Non affecté"} · champ informatif</p></div>
          <button onClick={onClose} className="text-brand-green/50" data-testid="guarantee-close"><X className="w-5 h-5" /></button>
        </div>
        <GuaranteeFields value={v.guarantee} detail={v.guarantee_detail} onChange={setV} />
        <div className="flex justify-end">
          <button onClick={save} disabled={busy} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold text-sm" data-testid="guarantee-save">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
